import { InternalIndex } from './internal-index';

export class InternalTable {
    TableName: string;
    PrimaryKey: string;
    AutoIncrement: boolean;
    Indexes: InternalIndex[];

    constructor(tableName: string, primaryKey: string, autoIncrement: boolean, indexes: InternalIndex[]) {
        this.TableName = tableName;
        this.PrimaryKey = primaryKey;
        this.AutoIncrement = autoIncrement;
        this.Indexes = indexes;
    }

    getIDBObjectStoreParameters(): IDBObjectStoreParameters {
        return {
            keyPath: this.PrimaryKey,
            autoIncrement: this.AutoIncrement
        };
    }
}